// external libs
import { Box, makeStyles, Typography } from '@material-ui/core'

// hooks
import useTranslate from '../../../../i18n/useTranslate'

// types
import type { SubmittedTimeline as SubmittedTimelineType } from '../../../../services/web/useProject'

import Tooltip from '../../../../control/tooltip/tooltip'
export interface SubmittedTimelineProps {
    submittedTimeline: SubmittedTimelineType
}

const SubmittedTimeline = (props: SubmittedTimelineProps) => {
    const { submittedTimeline } = props

    const translate = useTranslate()
    const currentLanguage = translate.languageStore.currentLanguage
    const classes = useStyles()

    const activeIndex = submittedTimeline.timelineList.findIndex((e) => !e.date)

    const formatDate = (dateString?: string, locale: string = 'en-GB'): string => {
        if (!dateString) return ''

        const date = new Date(dateString)

        return new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(date)
    }

    return (
        <Box width="100%">
            <Typography className={classes.headline}>
                {currentLanguage === 'th'
                    ? submittedTimeline.submitTypeInfo.nameTH
                    : submittedTimeline.submitTypeInfo.nameEN}
            </Typography>
            <Box className={classes.submittedTimeline}>
                {submittedTimeline.timelineList.map((e, index) => (
                    <Box
                        className={`${classes.timelineItem} ${e.date ? 'completed' : ''} ${
                            activeIndex === index ? 'active' : ''
                        }`}
                    >
                        {e.date ? (
                            <Tooltip
                                title={formatDate(e.date, currentLanguage === 'th' ? 'th-TH' : 'en-GB')}
                                placement="top"
                            >
                                <Box className="number">{index + 1}</Box>
                                <Typography className="title">
                                    {currentLanguage === 'th' ? e.timelineName.th : e.timelineName.en}
                                </Typography>
                            </Tooltip>
                        ) : (
                            <span>
                                <Box className="number">{index + 1}</Box>
                                <Typography className="title">
                                    {currentLanguage === 'th' ? e.timelineName.th : e.timelineName.en}
                                </Typography>
                            </span>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

const useStyles = makeStyles(() => ({
    headline: {
        fontSize: 16,
        fontWeight: 700,
        color: '#393E46',
        marginBottom: 16,
    },
    submittedTimeline: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 16,
        paddingInline: 16,
    },

    timelineItem: {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 1,
        position: 'relative',
        maxWidth: 200,
        textAlign: 'center',

        '& span': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 8,

            '& .number': {
                fontSize: 14,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 30,
                height: 30,
                borderRadius: '100%',
                background: '#D1D5DB',
                color: '#fff',
                zIndex: 1,
            },
        },

        '&.completed ': {
            cursor: 'pointer',

            '& .number': {
                backgroundColor: '#8EBD5F',
            },
        },

        '&.active .number': {
            backgroundColor: '#5F8EBD',
        },

        '&::after': {
            content: '""',
            position: 'absolute',
            top: 15,
            left: 'calc(50% + 8px)',
            width: '100%',
            height: 1,
            backgroundColor: '#8D8D8D',
        },

        '&:last-child::after': {
            content: 'none',
        },
    },
}))

export default SubmittedTimeline
